import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboardShell } from "@/components/layout/AdminDashboardShell";
import { AdminSettingsPage } from "@/features/admin-settings";

export const Route = createFileRoute("/settings/")({
  component: SettingsRoute,
});

function SettingsRoute() {
  return (
    <AdminDashboardShell>
      <AdminSettingsPage />
    </AdminDashboardShell>
  );
}
